import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import CategoryCake from './CategoryCake';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Occasion Cake'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Occasion Cake' : 'Edit Occasion Cake'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Occasion Cake', href: '/occasion-cake' },
          ]}
        />
        <CategoryCake />
      </Container>
    </Page>
  );
};

export default index;
